import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketDatasets from "components/Market/Datasets/Datasets";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketDatasetsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketDatasets {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const mapStateToProps = (state, ownProps) => {
  return {
    datasets: marketReducer.getDatasetsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketDatasetsContainer);
